import { Check, ChefHat, HandPlatter } from "lucide-react";

import { horaCurta } from "../lib/kds";

const SELOS = {
  producao: { icone: ChefHat, texto: "em produção", cor: "text-amber-600 dark:text-amber-400" },
  pronto: { icone: HandPlatter, texto: "pronto", cor: "text-sky-600 dark:text-sky-400" },
  entregue: { icone: Check, texto: "entregue", cor: "text-emerald-600 dark:text-emerald-400" },
};

/** Selo pequeno ao lado do item na comanda da mesa. Pedido do dono: bem
 *  simples — uma palavra e um ícone, sem cor de fundo disputando com o resto.
 *  Entregue leva a hora ("entregue 20:14").
 *
 *  `situacao` é o que o `useSituacaoItensMesa` devolve: `{situacao,
 *  entregue_at}` (ou só o texto, no formato antigo). */
export default function SeloItemMesa({ situacao }) {
  const info = typeof situacao === "string" ? { situacao } : (situacao || {});
  const s = SELOS[info.situacao];
  if (!s) return null;
  const hora = info.situacao === "entregue" ? horaCurta(info.entregue_at) : "";
  const Icone = s.icone;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold ${s.cor}`} data-e2e={`selo-${info.situacao}`}>
      <Icone className="w-3 h-3" />{s.texto}{hora ? ` ${hora}` : ""}
    </span>
  );
}
